import { IconClipboardList, IconTarget } from '@tabler/icons-react';
import { WelcomeExtensions } from '@ayocore/platform/client/components/Welcome/WelcomeExtensions';

/**
 * Регистрация Elita навигационных карточек на WelcomePage.
 * «Лиды» — стандартный список лидов (типы воронок задаются в инстансе).
 * «КП» — коммерческие предложения (сделки типа ELITA_ORDER).
 */
export function registerElitaWelcomeExtensions(): void {
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'crm-leads',
    label: 'Лиды',
    icon: IconTarget,
    url: '/crm/leads',
    order: 24,
  }));
  WelcomeExtensions.navigationCards.register(() => ({
    key: 'elita-orders',
    label: 'КП',
    icon: IconClipboardList,
    url: '/elita/orders',
    order: 25,
  }));
}
